<template>
	<header class="header">
		<img class="logo" :src="$import('logo.png')" alt="">

		<ul class="nav">
			<li
					v-for="(item, index) in navOptions"
					:key="index"
					v-if="item.isShow"
					:class="{ active: active === index }"
			>
				<AppLink :href="item.path" @click="handleClick(item, index)">{{ item.title }}</AppLink>
			</li>
		</ul>
	</header>
</template>

<script>
import {mapGetters} from "vuex";

export default {
	name: "index",
	data() {
		return {
			active: 0,
		}
	},
	computed: {
		...mapGetters(["navOptions"])
	},
	watch: {
		"$route.name"() {
			this.getCurPath();
		}
	},
	created() {
		this.getCurPath();
	},
	methods: {
		getCurPath() {
			let pathName = this.$route.name;
			this.active = this.navOptions.findIndex( item => pathName.includes(item.name) );
		},

		handleClick(item, index) {
			this.active = index;
		},
	}
}
</script>

<style lang="less" scoped>
.header {
	flex-shrink: 0;
	width: 100%;
	height: @headHeight;
	background-color: @white;
	display: flex;
	align-items: center;
	padding: 0 5%;
	border-bottom: 1px solid @greyLine;

	.logo {
		flex-shrink: 0;
		width: 260px;
		margin-right: 10%;
	}

	.nav {
		width: 100%;
		height: 100%;
		display: flex;

		>li {
			height: 100%;
			display: flex;
			align-items: center;
			margin: 0 20px;
			position: relative;
			font-size: 14px;
			color: #34364B;
			/*cursor: pointer;*/
			overflow: hidden;
		}

		>li::after {
			content: "";
			width: 100%;
			height: 3px;
			background-color: @red;
			position: absolute;
			bottom: 0;
			left: -300px;
			transition: all .3s;
		}

		>li:hover a,
		.active {
			color: @red;
		}

		>li:hover::after,
		.active::after {
			left: 0;
		}

		a:active {
			color: #34364B;
		}
	}
}
</style>
